import { styled as muiStyled } from "@mui/material/styles";
import { Grid, Box } from "@mui/material";
// Utils
import { useColors } from "../../Context/ColorsContext"
//Global Styled
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, tablet } = MediaQuerys;

export const BoxContainer = muiStyled(Box)(() => {
  const { colors } = useColors();

  return {
    backgroundColor: colors.footerColor,
    color: colors.white,
    minHeight: 6,
    width: "100%",
    position: "absolute",
    zIndex: 1100,
    left: 0,
    bottom: 0,
    right: 0,
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 1%), 0px 1px 1px 0px rgb(0 0 0 / 1%), 0px 1px 3px 0px rgb(0 0 0 / 12%);",
    [mobile]: {
      width: "100%",
      position: "fixed",
    },
    [tablet]: {
      width: "100%",
      position: "fixed",
    }
  }
});

export const FooterContainer = muiStyled(Grid)(({ theme }) => ({
	width: '100vw',
  margin: 'auto',
  display: 'flex',
  direction: "row",
  justifyContent: "end",
  alignItems: "center",
  padding: 1,
  paddingRight: 25,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [mobile]: {
    paddingRight: 10,
  }
}));

export const ImageContainer = muiStyled("img")(() => ({
  width: 10,
}));

export const FooterText = muiStyled("span")(() => ({
  fontSize: "11px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "block",
}));
